import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";

import HomePage from "./screen/index";
import AboutUsPage from "./screen/aboutus";
import FrameworkPage from "./screen/framework";
import SolutionPage from "./screen/solution";
import LocationPage from "./screen/location";
import MissionPage from "./screen/mission";
import YoutubePage from "./screen/youtube";
import PrivacyPage from "./screen/privacy";

import { LoginPage } from "./contents-manager/app/LoginPage";
import { SiteContentPage } from "./contents-manager/app/SiteContentPage";
import { HistoryPage } from "./contents-manager/app/HistoryPage";
import { ConfigPage } from "./contents-manager/app/ConfigPage";
import { StoragePage } from "./contents-manager/app/StoragePage";
import { AdminAuthProvider } from "./contents-manager/auth/AdminAuthProvider";

import "./App.css";
import "./contents-manager/components/admin.css";

function App() {
  const routerBaseName = process.env.PUBLIC_URL || undefined;

  return (
    <Router basename={routerBaseName}>
      <Routes>
        {/* Public site */}
        <Route path="/" element={<HomePage />} />
        <Route path="/aboutus" element={<AboutUsPage />} />
        <Route path="/framework" element={<FrameworkPage />} />
        <Route path="/solution" element={<SolutionPage />} />
        <Route path="/location" element={<LocationPage />} />
        <Route path="/mission" element={<MissionPage />} />
        <Route path="/videos" element={<YoutubePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />

        {/* Admin site (kept under /admin/*) */}
        <Route
          path="/admin/login"
          element={
            <AdminAuthProvider>
              <LoginPage />
            </AdminAuthProvider>
          }
        />
        <Route
          path="/admin/site-content"
          element={
            <AdminAuthProvider>
              <SiteContentPage />
            </AdminAuthProvider>
          }
        />
        <Route
          path="/admin/history"
          element={
            <AdminAuthProvider>
              <HistoryPage />
            </AdminAuthProvider>
          }
        />
        <Route
          path="/admin/config"
          element={
            <AdminAuthProvider>
              <ConfigPage />
            </AdminAuthProvider>
          }
        />
        <Route
          path="/admin/storage"
          element={
            <AdminAuthProvider>
              <StoragePage />
            </AdminAuthProvider>
          }
        />
        <Route path="/admin" element={<Navigate replace to="/admin/site-content" />} />

        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
